var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09562 1.06974C1.15136 1.01999 1.20709 0.995117 1.31857 0.995117C1.40218 0.995117 1.48579 1.01999 1.56939 1.06974L7.39405 6.29345C7.44979 6.3432 7.50553 6.41782 7.50553 6.49245C7.50553 6.59195 7.44979 6.6417 7.39405 6.69145L1.56939 11.9152C1.48579 11.9649 1.40218 11.9898 1.31857 11.9898C1.20709 11.9898 1.15136 11.9649 1.09562 11.9152L0.538234 11.4177C0.454626 11.3679 0.426757 11.3182 0.426757 11.2187C0.426757 11.144 0.454626 11.0694 0.538234 10.9948L5.58255 6.49245L0.538234 1.99011C0.454627 1.94036 0.426758 1.86574 0.426758 1.76624C0.426758 1.69161 0.454627 1.61699 0.538234 1.56724L1.09562 1.06974Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBlack);
export default __webpack_public_path__ + "static/media/chevron-black.40c4f3c324595b7f43db122e868f2c87.svg";
export { ForwardRef as ReactComponent };